var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8537 32.0001C12.8537 27.2069 4.8312 19.1845 0.0380859 19.1845C4.8312 19.1845 12.8537 11.162 12.8537 6.3689C12.8537 11.162 20.8761 19.1845 25.6692 19.1845C20.8761 19.1845 12.8537 27.2069 12.8537 32.0001Z",
    fill: "#FFD83B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8539 24.2322C12.8539 22.3449 9.69344 19.1845 7.80615 19.1845C9.69344 19.1845 12.8539 16.024 12.8539 14.1367C12.8539 16.024 16.0144 19.1845 17.9016 19.1845C16.0134 19.1845 12.8539 22.3439 12.8539 24.2322Z",
    fill: "#F3C432"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7886 14.1367C21.7886 11.828 17.9242 7.96356 15.6155 7.96356C17.9242 7.96356 21.7886 4.09911 21.7886 1.79043C21.7886 4.09911 25.6531 7.96356 27.9618 7.96356C25.6531 7.96356 21.7886 11.828 21.7886 14.1367ZM3.80248 31.5397C3.80248 30.3504 1.81234 28.3602 0.623047 28.3602C1.81234 28.3602 3.80248 26.3701 3.80248 25.1808C3.80248 26.3701 5.79262 28.3602 6.98191 28.3602C5.79262 28.3612 3.80248 30.3514 3.80248 31.5397ZM7.90358 8.82532C7.90358 7.17469 5.14155 4.41266 3.49093 4.41266C5.14155 4.41266 7.90358 1.65063 7.90358 0C7.90358 1.65063 10.6656 4.41266 12.3162 4.41266C10.6656 4.41266 7.90358 7.17469 7.90358 8.82532Z",
    fill: "#FFD83B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.165cf68781280042f50a1ed71485b81f.svg";
export { ForwardRef as ReactComponent };